import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { FaCircleCheck } from 'react-icons/fa6'
import CounterSection from './CounterSection'
import { teamMembers } from '../array'
import { Link } from 'react-router-dom'

const AboutUs = () => {
    return (
        <>
            <Header />
            <section className="relative flex justify-center items-center bg-gradient-to-r from-black to-logo text-white md:py-24    py-12 w-full overflow-hidden">

                {/* Content on Top of the Video */}
                <div className="relative z-10 container mx-auto text-center md:px-24 px-6">
                    <h1 className="md:text-4xl text-2xl font-bold mb-4 animate-fadeIn">
                        About Us
                    </h1>
                    <p className='md:w-[70%] text-center mx-auto py-3'>
                        We Innovate, Improve and Empower!
                    </p>
                    {/* <p className="mb-6 animate-fadeIn">
                        This program is only for those who want to express their feelings in their hard times but find no one to hear.
                        This is a supportive hand to let you out of downturns and bring you to the equal level where everyone of us stands.
                        Write us your story, express your passions and feels. Express your troubles. Our agent will reach you out with a solution.
                    </p> */}
                    {/* <button className="bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg">
                        Donate Now
                    </button> */}
                </div>
            </section>

            <div className="py-16 md:px-12 px-6">
                <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">

                    <div>
                        <img src={require('../assets/images/about-us.png')} alt="Charity work" className="rounded-lg" />
                    </div>
                    <div className="flex flex-col justify-center">
                        <div className="mb-4">
                            <h2 className="text-3xl font-semibold ">
                                Exclusive Agency For Technology Solutions
                            </h2>
                            <div className="border-t-4 border-orange-500 mt-2 w-20 rounded-full"></div>
                        </div>


                        <p className="text-lg mb-4">
                            AS-Tech Community (SMC-PVT) is a premier IT company that delivers cutting-edge technology solutions to businesses worldwide. Our expert team crafts tailored solutions that drive profitability, boost market presence and propel growth. With a proven track record of success, we empower companies to thrive in the digital landscape.
                        </p>
                        <h2 className="text-lg flex">
                            AS-Tech was Founded by Ms. Anum Shaheen in 2020 to empower tech enthusiasts to achieve their career aspirations. Through our growth and expansion, we have successfully connected talented individuals with external job opportunities and projects. As a collaborative team, we drive business success for our global clients.
                        </h2>
                        <h2>
                            <Link to="https://theastc.com" className="text-logo">
                                More About Us
                            </Link>
                        </h2>
                        <CounterSection />
                    </div>


                </div>
            </div >

            <div className="py-16 md:px-12 px-6">
                <div className="container mx-auto grid grid-cols-1 md:grid-cols-2">

                    <div className="flex flex-col justify-center bg-gradient-to-r from-black to-logo p-6 text-white">
                        <div className="mb-4">
                            <h2 className="text-3xl font-semibold">
                                We Work With 5 Years of Experience
                            </h2>
                            <div className="border-t-4 border-orange-500 mt-2 w-20 rounded-full"></div>
                        </div>

                        <p className="text-lg my-4">
                            Founded in 2020, our journey began with a group of visionary individuals united in a WhatsApp group, passionate about tech entrepreneurship. Through idea-sharing and mutual support, we evolved into a thriving global network, empowering entrepreneurs with cutting-edge technology and networking opportunities.
                        </p>
                        <div>
                            <ul className="space-y-4 grid grid-cols-2">
                                <li className="flex items-center">
                                    <span className="text-white mr-2"><FaCircleCheck size={18} /> </span> Business Development
                                </li>
                                <li className="flex items-center">
                                    <span className="text-white mr-2"><FaCircleCheck size={18} /> </span> Strategic Solutions
                                </li>
                                <li className="flex items-center">
                                    <span className="text-white mr-2"><FaCircleCheck size={18} /> </span> Planning & Maintenance
                                </li>
                                <li className="flex items-center">
                                    <span className="text-white mr-2"><FaCircleCheck size={18} /> </span> Free Consultation
                                </li>
                                <li className="flex items-center">
                                    <span className="text-white mr-2"><FaCircleCheck size={18} /> </span> Expert Advice
                                </li>
                                <li className="flex items-center">
                                    <span className="text-white mr-2"><FaCircleCheck size={18} /> </span> Affordable Prices
                                </li>
                                <li className="flex items-center">
                                    <span className="text-white mr-2"><FaCircleCheck size={18} /> </span> Quick Process
                                </li>
                                <li className="flex items-center">
                                    <span className="text-white mr-2"><FaCircleCheck size={18} /> </span> Online Support
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className='flex justify-center items-center'>
                        <img src={require('../assets/images/about-back.png')} alt="Charity work" className="rounded-lg" />
                    </div>
                </div>
            </div>


            <div className='container mx-auto w-full py-16 md:px-12 px-6'>
                <div className='flex flex-col justify-center items-center'>
                    <div className="mb-4">
                        <h2 className="text-3xl font-semibold">Dedicated Team</h2>
                        <div className="border-t-4 border-orange-500 mt-2 w-20 rounded-full mx-auto"></div>
                    </div>

                    <p className="text-lg mb-4 md:w-[80%] text-center">
                        Lorem Ipsum is simply dummy text of the printing and typesetting has been the industry's standard dummy text ever since.
                    </p>
                </div>

                {/* Map function to dynamically generate team members */}
                <div className='grid md:grid-cols-3 grid-cols-1 gap-6'>
                    {teamMembers.map((member) => (
                        <div key={member.id} className='flex flex-col justify-center items-center'>
                            <img src={member.image} alt={member.name} className='w-[100%] h-80' />
                            <h2 className='text-xl font-bold py-2'>{member.name}</h2>
                            <p>{member.role}</p>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </>
    )
}

export default AboutUs
